export default __webpack_public_path__ + "dist/media/Cross.d2015014.svg";